<script>
import {formatPhone, copyText as copyToClipboard} from "@js/helpers.ts";
import {useThemeStore} from "@js/store/ThemeStore.js";
import {contacts} from "@js/company_details.ts";

export default {
    name: "LogisticDepartmentPhone",
    computed: {
        formattedPhone() {
            const raw = contacts?.logistics_department_phone || "";
            return raw ? formatPhone(raw) : "";
        },
        telHref() {
            return `tel:+${String(contacts?.logistics_department_phone || "").replace(/\D/g, "")}`;
        }
    },
    methods: {
        handleCopy() {
            if (!this.formattedPhone) return;
            copyToClipboard(this.formattedPhone);
            useThemeStore().addToast("Телефон скопирован", "success");
        }
    },
    setup() {
        return {contacts};
    }
};
</script>

<template>
    <div class="flex items-center">
        <a :href="telHref" class="md:hidden" aria-label="Позвонить">
            {{ formattedPhone }}
        </a>
        <button type="button" @click="handleCopy"
                class="hidden md:inline cursor-pointer transition bg-transparent p-0 m-0"
                aria-label="Скопировать телефон">
            {{ formattedPhone }}
        </button>
    </div>
</template>

<style scoped lang="scss"></style>
